<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <PrintHeaderSSPSlim />
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>3 {{ $t('zs') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('zsLocationState') }}</div>
        <div>
          {{ locationStateLabel(project.salesReport && project.salesReport.salesZsLocationState) }}
        </div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.salesZsWithCoverAttachments"
      fieldName="zsWithCoverAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';

export default {
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: { type: Object, required: true },
    pageNumber: { type: Number, default: 3 },
    pageCount: { type: Number, default: 3 },
  },
  methods: {
    locationStateLabel(state) {
      return state ? this.$t(state) : '-';
    },
  },
};
</script>
